import { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Shield, Users, Heart } from 'lucide-react';
import Footer from '@/components/Footer';
interface AuthDesktopProps {
  children: ReactNode;
  invitationToken?: string | null;
  familyName?: string | null;
  invitationDetails?: any;
}
export const AuthDesktop = ({
  children,
  invitationToken,
  familyName,
  invitationDetails
}: AuthDesktopProps) => {
  return <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-2/5 relative overflow-hidden bg-[#2a0f47]">
        {/* Background image */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{backgroundImage: 'url(/hero-family.jpg)'}}></div>
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2a0f47] via-[#2a0f47]/80 to-[#2a0f47]/60"></div>
        <div className="relative flex flex-col justify-between p-12 text-white h-full z-10">
          {/* Top content */}
          <div className="space-y-8">
            {/* Logo and brand */}
            <div className="flex items-center gap-2">
              <div className="bg-[#3d1561] rounded-full p-2">
                <img src="/logo-simplified.png" alt="Clan" className="h-6 w-6" />
              </div>
              <span className="text-xl font-bold">Clan</span>
            </div>
            
            {/* Main content */}
            <div className="space-y-4 max-w-md">
              <h1 className="text-3xl font-bold leading-tight">
                Le quartier général
                <br />
                <span className="text-white/90">de votre famille</span>
              </h1>
              <p className="text-base text-white/80">
                Gérez vos événements, tâches et contacts familiaux en toute simplicité.
              </p>
            </div>
          </div>

          {/* Testimonial at bottom */}
          <div className="space-y-4 max-w-md">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="flex items-start gap-3">
                <div className="text-white/60 text-2xl leading-none">"</div>
                <div className="flex-1">
                  <p className="text-white/90 text-sm italic leading-relaxed">
                    Clan a transformé notre organisation familiale. Enfin une app qui nous réunit tous !
                  </p>
                  <div className="mt-3 flex items-center gap-2">
                    <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                      <Heart className="h-4 w-4 text-white/80" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">Marie</p>
                      <p className="text-white/60 text-xs">Maman de 3 enfants</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Right side - Form */}
      <div className="lg:w-3/5 flex flex-col bg-background">
        <div className="flex-1 flex justify-center items-center px-8 lg:px-12">
          <div className="w-full max-w-sm mx-auto space-y-8">
            {/* Header */}
            <div className="text-center space-y-2">
              <div className="flex lg:hidden justify-center mb-4">
                <div className="bg-card rounded-full p-3 shadow-medium">
                  <Shield className="h-8 w-8 text-primary" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-foreground">Bienvenue</h2>
              <p className="text-muted-foreground">
                {invitationToken ? `Vous êtes invité(e) à rejoindre une famille` : 'Connectez-vous ou créez votre compte'}
              </p>
              {invitationToken && familyName && <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
                  <CheckCircle className="h-4 w-4 mr-2" />
                  {familyName ? `Invitation pour "${familyName}"` : 'Invitation Clan'}
                </Badge>}
            </div>

            {/* Form Card */}
            <Card className="shadow-large border-0">
              <CardHeader className="text-center pb-4">
                <CardTitle className="flex items-center justify-center gap-2 text-lg">
                  <Users className="h-5 w-5 text-primary" />
                  Votre espace famille
                </CardTitle>
                {invitationDetails?.personDetails && <CardDescription className="text-sm text-muted-foreground">
                    Profil : {invitationDetails.personDetails.firstName} {invitationDetails.personDetails.lastName}
                    {invitationDetails.personDetails.category === 'family' && invitationDetails.personDetails.familyRole && <span> • {invitationDetails.personDetails.familyRole === 'son' ? 'Fils' : invitationDetails.personDetails.familyRole === 'daughter' ? 'Fille' : invitationDetails.personDetails.familyRole === 'spouse' ? 'Conjoint(e)' : invitationDetails.personDetails.familyRole}</span>}
                  </CardDescription>}
              </CardHeader>
              <CardContent>
                {children}
              </CardContent>
            </Card>
            
          </div>
        </div>
        <Footer />
      </div>
    </div>;
};